<template>
    <div>
        <div class="row mt-5">
            <div class="col-3 mb-2">
              
                <form method="post" class="" @submit.prevent="onGetLedgerBitcoinAddress">
                    <label for="accountIndex">Account Index: (m/44'/195'/0'/0/x)</label>
                    <input type="text" class="form-control" id="accountIndex" v-model="accountIndex" size="6">
                    <input type="submit" class="btn btn-info mt-1" @click="onGetLedgerBitcoinAddress" value="Load">
                </form>

            </div>

            <div class="col-4">
                <label>
                    Address:
                </label>
                <p class="bold">
                    {{trxAddress}}
                </p>
            </div>
            <div class="col-3">
                <label>
                    HD Path:
                </label>
                <p class="bold">
                    {{hdPath}}
                </p>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary btn-sm mt-3 mr-1" @click="logout">Logout</button>
                <button class="btn btn-primary btn-sm mt-3" @click="showAddAddressModal = true">Add New Address</button>
                <button class="btn btn-outline-secondary btn-sm mt-1 w-100" @click="showReceive = true" v-if="trxAddress !== 'N/A'">📥 Receive</button>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-7">
                <div class="total-usdt-banner" v-if="balances.length">
                    <span class="tub-label">Total Value</span>
                    <span class="tub-value">{{ totalUsdtStr }}</span>
                    <button class="tub-refresh" @click="loadBalances" :disabled="tokensLoading" title="Refresh USDT value">
                        <span v-if="tokensLoading" class="spinner-border spinner-border-sm" role="status"></span>
                        <span v-else>↻</span>
                    </button>
                </div>
                <div class="row">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th scope="col">Asset</th>
                            <th scope="col">Balance</th>
                            <th scope="col">Value (USDT)</th>
                            <th scope="col">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="tokensLoading">
                            <td colspan="4" class="text-center text-muted small py-1">
                                <span class="spinner-border spinner-border-sm mr-1" style="width:.75rem;height:.75rem"></span>
                                {{ pricingProgressMsg }}
                            </td>
                        </tr>
                        <tr v-for="balance in sortedBalances" v-bind:key="balance.contractAddress || balance.ticker">
                            <td>{{balance.ticker}}</td>
                            <td>{{balance.balance}}</td>
                            <td>{{ balance.usdValue != null ? '$' + balance.usdValue.toFixed(2) : priceOf(balance.ticker, balance.rawBalance !== undefined ? balance.rawBalance : balance.balance) }}</td>
                            <td>
                                <button class="btn btn-success"
                                        @click="openModal(balance.ticker, balance.balance, balance.type)">Send
                                    {{balance.ticker}}
                                </button>

                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-sm-5">
                <!-- Address List Table -->
                <div class="row">
                    <div class="col-12">
                        <table class="table table-striped text-center">
                            <thead>
                                <tr>
                                    <th scope="col-2">Name</th>
                                    <th scope="col-6">Address</th>
                                    <th scope="col-4">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(entry, index) in addresses" :key="index">
                                    <td>{{ entry.name }}</td>
                                    <td>{{ entry.address }}</td>
                                    <td>
                                        <button class="btn btn-info btn-sm mx-3" @click="copyAddress(entry.address)">Copy</button>
                                        <button class="btn btn-danger btn-sm" @click="deleteAddress(index)">Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <div class="rpc-panel">
                    <span class="rpc-title">RPC Nodes</span>
                    <span v-for="rpc in rpcList" :key="rpc.url"
                        class="rpc-item"
                        :class="{ 'rpc-active': activeRpc === rpc.url }"
                        @click="switchRpc(rpc.url)">
                        <span class="rpc-dot" :class="rpcStatus[rpc.url]"></span>
                        {{ rpc.label }}
                    </span>
                </div>
            </div>
        </div>

        <!-- ── Transaction Chart ─────────────────────────────────────── -->
        <div class="row mt-4">
            <div class="col-12">
                <div class="chart-panel">
                    <div class="chart-toolbar">
                        <span class="chart-panel-title">Transaction History</span>

                        <div class="chart-input-group">
                            <input
                                type="text"
                                class="form-control form-control-sm chart-addr-input"
                                placeholder="Tron address (T…)"
                                v-model="chartAddress"
                                @keyup.enter="loadChart"
                            />
                            <button class="btn btn-tron btn-sm" @click="loadChart" :disabled="chartLoading">
                                <span v-if="chartLoading">Loading…</span>
                                <span v-else>Load Chart</span>
                            </button>
                            <button
                                v-if="trxAddress !== 'N/A'"
                                class="btn btn-outline-secondary btn-sm"
                                @click="chartAddress = trxAddress; loadChart()"
                                title="Use my Ledger address">
                                My Address
                            </button>
                        </div>

                        <div class="chart-toggles">
                            <button
                                class="btn btn-sm"
                                :class="chartMode === 'count' ? 'btn-tron' : 'btn-outline-secondary'"
                                @click="setChartMode('count')">
                                TX Count
                            </button>
                            <button
                                class="btn btn-sm"
                                :class="chartMode === 'volume' ? 'btn-tron' : 'btn-outline-secondary'"
                                @click="setChartMode('volume')">
                                TRX Volume
                            </button>
                        </div>

                        <div class="chart-toggles">
                            <button v-for="d in [30,60,90]" :key="d"
                                class="btn btn-sm"
                                :class="chartDays === d ? 'btn-tron' : 'btn-outline-secondary'"
                                @click="chartDays = d; renderChart()">
                                {{ d }}d
                            </button>
                        </div>
                    </div>

                    <div class="chart-summary" v-if="chartStats.total > 0">
                        <span class="chart-stat">
                            <strong>{{ chartStats.total }}</strong> TXs
                        </span>
                        <span class="chart-stat">
                            <span class="stat-in">▲ {{ chartStats.received }} TRX received</span>
                        </span>
                        <span class="chart-stat">
                            <span class="stat-out">▼ {{ chartStats.sent }} TRX sent</span>
                        </span>
                        <span class="chart-stat text-muted">
                            Last {{ chartDays }} days
                        </span>
                    </div>

                    <div class="chart-wrapper">
                        <canvas ref="txChart"></canvas>
                        <div v-if="!chartLoaded && !chartLoading" class="chart-placeholder">
                            Enter a Tron address above and click <strong>Load Chart</strong>
                        </div>
                        <div v-if="chartLoading" class="chart-placeholder">
                            <div class="spinner-border text-danger" role="status"></div>
                            <p class="mt-2 mb-0">Fetching transactions…</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal v-model="showReceipt" title="TX ID">
            <p class="small">
                <a :href="'https://tronscan.org/#/transaction/'+txid" target="_blank">{{txid}}</a>
                <br />
                <br />
                <input type="text" class="form-control form-control-sm" v-model="txid" />
            </p>
        </Modal>

        <Modal v-model="showModal" :title="'Send '+ modalTicker">
            <form novalidate>
                <div class="form-group">
                    <label for="inputToAddress">To Address</label>
                    <input id="inputToAddress" type="email" class="form-control" placeholder="To Address"
                           v-model="modalToAddress"/>
                </div>
                <div class="form-group">
                    <label for="inputAmount">Amount ({{modalTicker}})</label>
                    <input id="inputAmount" type="text" class="form-control" placeholder="Amount"
                           v-model="modalAmount"/>
                </div>

                <div class="row modal-footer">
                    <div class="col-sm-12">
                        <div class="float-left">
                            <button class="btn btn-danger" type="button" @click="closeModal()">Cancel</button>
                        </div>
                        <div class="float-right">
                            <button class="btn btn-success" type="button" @click="sendTransaction(modalTicker)">Send</button>
                        </div>
                    </div>
                </div>
            </form>
        </Modal>

        <!-- New Address Modal -->
        <Modal v-model="showAddAddressModal" title="Add New Address">
            <form novalidate @submit.prevent="submitNewAddress">
                <div class="form-group">
                    <label for="inputName">Name</label>
                    <input required id="inputName" type="text" class="form-control" placeholder="Name" v-model="newAddressName"/>
                </div>
                <div class="form-group">
                    <label for="inputNewAddress">Address</label>
                    <input required id="inputNewAddress" type="text" class="form-control" placeholder="Address" v-model="newAddress"/>
                </div>
                <div class="row modal-footer">
                    <div class="col-sm-12">
                        <div class="float-left">
                            <button class="btn btn-danger" type="button" @click="closeAddAddressModal">Cancel</button>
                        </div>
                        <div class="float-right">
                            <button class="btn btn-success" type="submit">Submit</button>
                        </div>
                    </div>
                </div>
            </form>
        </Modal>

        <ReceiveModal v-if="showReceive" :address="trxAddress" chain="tron" @close="showReceive = false" />

        <!-- Transaction History -->
        <!-- Address Matrix / Tree -->
        <div class="row mt-4">
            <div class="col-12">
                <div class="chart-panel">
                    <div class="chart-panel-title mb-2">Address Overview</div>
                    <AddressMatrix
                        :cells="matrixCells"
                        :active-index="accountIndex"
                        accent-color="#FF0013"
                        unit="TRX"
                        :decimals="6"
                        :loading="matrixLoading"
                        root-label="m/44'/195'/0'/0"
                        hint="Tron's Ledger app doesn't expose a chaincode — only indices you've connected via Ledger appear here."
                        @refresh="loadMatrix(true)"
                        @select="onMatrixSelect" />
                </div>
            </div>
        </div>

        <WalletTxHistory chain="tron" :address="trxAddress" accent-color="#FF0013" />
    </div>

</template>

<script>
    import Trx from '@ledgerhq/hw-app-trx';
    import TransportWebHID from "@ledgerhq/hw-transport-webhid";
    import TransportWebUSB from "@ledgerhq/hw-transport-webusb";
    import TronWeb from "tronweb";
    import numeral from 'numeral';
    import BigNumber from 'bignumber.js';
    import '@kouts/vue-modal/dist/vue-modal.css';
    import axios from 'axios';
    import { fetchPrices, formatUsd } from '../services/priceService';
    import { saveAccount, getAccounts } from '../services/accountService';
    import AddressMatrix from './AddressMatrix.vue';
    import { getCustomTokens } from '../services/tokenService';
    import { loadTronTokens } from '../services/tokenLoader';
    import { getAddresses, saveAddress, deleteAddress as deleteAddressPb } from '../services/pbService';
    import eventBus from '../services/eventBus';
    const ReceiveModal = () => import('./ReceiveModal.vue');
    import { Chart, BarElement, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend, BarController, LineController } from 'chart.js';
    Chart.register(BarElement, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend, BarController, LineController);


    const TRON_RPC_LIST = [
        { label: 'TronGrid (Official)', url: 'https://api.trongrid.io' },
        { label: 'TronStack',           url: 'https://api.tronstack.io' },
        { label: 'NowNodes',            url: 'https://trx.nownodes.io' },
    ];

    let activeRpcUrl = TRON_RPC_LIST[0].url;

    const tronWeb = new TronWeb({
        fullNode: activeRpcUrl,
        solidityNode: activeRpcUrl,
    });

    tronWeb.setAddress('TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t');

    let transport = null;
    let trx = null;
/*
    var a = new BN(100_000_000, 10);
    var b = new BN(18, 10);

    var res = a.pow(b);
    console.log(res.toString(10));  // 57047

*/


    const trc10Tokens = [
        {
            "ticker": "BTT",
            "tokenId": "1002000",
            "prec": 6
        }
    ];

    const trc20Tokens = [
        { "ticker": "USDT",  "address": "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",  "prec": 6  },
        { "ticker": "USDC",  "address": "TEkxiTehnzSmse5XcPGWjZ9mBe1i1oSwCN",  "prec": 6  },
        { "ticker": "USDD",  "address": "TPYmHEhy5n8TCEfYGqW2rPxsghdbiqY4Rh",  "prec": 18 },
        { "ticker": "WIN",   "address": "TLa2f6VPqDgRE67v1736s7bJ8Ray5wYjU7",  "prec": 6  },
        { "ticker": "BTTC",  "address": "TAFjULxiVgT4qWk6UZwjqwZXTSaGaqnVp4", "prec": 18 },
        { "ticker": "SUN",   "address": "TSSMHYeV2uE9qYH95DqyoCuNCzEL1NvU3S",  "prec": 18 },
        { "ticker": "JST",   "address": "TCFLL5dx5ZJdKnWuesXxi1VPwjLVmWZZy9",  "prec": 18 },
    ];

    export default {
        name: 'HelloWorld',
        components: { ReceiveModal, WalletTxHistory: () => import('./WalletTxHistory.vue'), AddressMatrix },
        props: {
            msg: String
        },
        data() {
            return {
                trxAddress: "N/A",
                accountIndex: 0,
                hdPath: "N/A",
                matrixCells: [],
                matrixLoading: false,
                balances: [],
                tokensLoading: false,
                pricingProgress: null,
                showModal: false,
                showReceipt: false,
                modalTicker: "",
                modalToAddress: "",
                modalAmount: 0,
                modalTxType: "",
                txid: "",
                showAddAddressModal: false, // to control the display of the new address modal
                newAddressName: '',
                newAddress: '',
                addresses: [],
                rpcList: TRON_RPC_LIST,
                activeRpc: TRON_RPC_LIST[0].url,
                rpcStatus: {},
                // pricing
                prices: {},
                priceTimer: null,
                showReceive: false,
                // chart
                chartAddress: '',
                chartMode: 'count',
                chartDays: 30,
                chartLoading: false,
                chartLoaded: false,
                chartInstance: null,
                chartStats: { total: 0, received: '0', sent: '0' },
            }
        },
        computed: {
            // Native TRX pinned to the top row, everything else sorted by USD value descending.
            sortedBalances() {
                const native = this.balances.filter(b => b.type === 'trx');
                const rest = this.balances.filter(b => b.type !== 'trx')
                    .slice()
                    .sort((a, b) => this.usdValueNum(b) - this.usdValueNum(a));
                return [...native, ...rest];
            },
            totalUsdt() {
                return this.balances.reduce((sum, b) => sum + Math.max(this.usdValueNum(b), 0), 0);
            },
            totalUsdtStr() {
                return formatUsd(this.totalUsdt) + ' USDT';
            },
            pricingProgressMsg() {
                const p = this.pricingProgress;
                if (!p) return 'Scanning all tokens…';
                if (p.stage === 'binance') return 'Pricing via Binance…';
                if (p.stage === 'coingecko') return `Pricing ${p.current}/${p.total} tokens via CoinGecko…`;
                return 'Scanning all tokens…';
            },
        },
        methods: {
            openModal(ticker, amount, type) {
                this.showModal = true;
                this.modalTicker = ticker;
                this.modalToAddress = "";
                this.modalAmount = amount;
                this.modalTxType = type;
                this.txid = "";
                this.showReceipt = false;
            },

            openAddAddressModal() {
                this.showAddAddressModal = true;
            },

            isValidTronAddress(address) {
                const ethAddressPattern = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
                return ethAddressPattern.test(address);
            },

            async submitNewAddress() {

                if (!this.isValidTronAddress(this.newAddress)) {
                        alert ("Please enter a valid Tron address.");
                        return;
                    }

                try {
                    await saveAddress({
                        label: this.newAddressName,
                        address: this.newAddress,
                        chain: 'tron',
                        notes: '',
                        aml_risk_level: 'unknown',
                    });

                    // On successful save, fetch the updated address list
                    await this.fetchAddresses();

                    // Clear the form fields
                    this.newAddressName = '';
                    this.newAddress = '';

                    // Close the modal
                    this.closeAddAddressModal();
                } catch (error) {
                    console.error('Error submitting new address:', error);
                    alert('Failed to add new address. Please try again.');
                }
            },

            async fetchAddresses() {
                try {
                    const res = await getAddresses();
                    this.addresses = res.items
                        .filter(r => r.chain === 'tron' || r.chain === 'all')
                        .map(r => ({ id: r.id, name: r.label, address: r.address }));
                } catch (error) {
                    console.error('Error fetching addresses:', error);
                }
            },

            copyAddress(address) {
                navigator.clipboard.writeText(address).then(() => {
                    alert('Address copied to clipboard!');
                });
            },

            async deleteAddress(index) {
                const entry = this.addresses[index];
                try {
                    if (entry.id) await deleteAddressPb(entry.id);
                    this.addresses.splice(index, 1);
                } catch (error) {
                    console.error('Error deleting address:', error);
                }
            },

            closeAddAddressModal() {
                this.showAddAddressModal = false;
            },

            logout() {
                localStorage.removeItem('isLoggedIn');
                this.isLoggedIn = false;
            },

            closeModal() {
                this.showModal = false;
                this.modalTicker = "";
                this.modalToAddress = "";
                this.modalAmount = 0;
                this.modalTxType = "";
            },

            async sendTransaction(ticker) {
                tronWeb.setAddress(this.modalToAddress);

                switch (this.modalTxType) {
                    case "trx":
                        console.log("Transfer TRX");
                        try {
                            console.log(this.modalAmount * Math.pow(10, 6));

                            const sendTrxObj = await tronWeb.transactionBuilder.sendTrx(
                                this.modalToAddress,
                                this.modalAmount * Math.pow(10, 6),
                                this.trxAddress
                            );
                            console.log(sendTrxObj);


                            try {
                                this.notice('info', 'Confirm Transaction on ledger', `Confirm Transaction on ledger`, 10);
                                const hdPath = `44'/195'/0'/0/${this.accountIndex}`;
                                console.log(hdPath, sendTrxObj.raw_data_hex);
                                const tronAddress = await trx.getAddress(hdPath, false);
                                console.log(tronAddress);
                                const sign = await trx.signTransaction(hdPath, sendTrxObj.raw_data_hex, [], 105);
                                const signedTx = sendTrxObj;
                                signedTx.signature = [sign];
                                console.log("signedTx:", signedTx);
                                const receipt = await tronWeb.trx.sendRawTransaction(
                                    signedTx
                                );
                                if (receipt.result === true) {
                                    console.log(receipt);
                                    this.notice('success', 'Successful', `Successfully sent transaction`);
                                    this.closeModal();
                                    this.txid = receipt.txid;
                                    this.showReceipt = true;
                                    const hey = this;
                                    setTimeout(async function () {
                                        await hey.loadBalances();
                                    }, 30000);

                                }else{
                                    this.notice('error', 'Tranaction Error', "Tranaction Error", 10);
                                }

                                // await this.loadBalances();
                            } catch (error) {
                                console.log(error)
                                this.notice('error', 'Tranaction Error', error.toString(), 10);
                            }


                        } catch (e) {
                            console.error("Transfer Error", e);
                            this.notice('error', 'Error in transfer', e.toString(), 5);

                        }


                        break;
                    case "trc10":
                        console.log("Transfer TRC-10");
                        const trc10Token = trc10Tokens.find(element => element.ticker === ticker);
                        console.log(trc10Token);
                        console.log(this.modalToAddress);

                        try {
                            console.log(this.modalAmount * Math.pow(10, trc10Token.prec));

                            const sendTrxObj = await tronWeb.transactionBuilder.sendAsset(
                                this.modalToAddress,
                                this.modalAmount * Math.pow(10, 6),
                                trc10Token.tokenId,
                                this.trxAddress
                            );
                            console.log(sendTrxObj);

                            try {
                                this.notice('info', 'Confirm Transaction on ledger', `Confirm Transaction on ledger`, 10);
                                const hdPath = `44'/195'/0'/0/${this.accountIndex}`;
                                console.log(hdPath, sendTrxObj.raw_data_hex);
                                const tronAddress = await trx.getAddress(hdPath, false);
                                console.log(tronAddress);
                                const sign = await trx.signTransaction(hdPath, sendTrxObj.raw_data_hex, [], 105);
                                const signedTx = sendTrxObj;
                                signedTx.signature = [sign];
                                console.log("signedTx:", signedTx);
                                const receipt = await tronWeb.trx.sendRawTransaction(
                                    signedTx
                                );
                                if (receipt.result === true) {
                                    console.log(receipt);
                                    this.notice('success', 'Successful', `Successfully sent transaction`);
                                    this.closeModal();
                                    this.txid = receipt.txid;
                                    this.showReceipt = true;
                                    const hey = this;
                                    setTimeout(async function () {
                                        await hey.loadBalances();
                                    }, 30000);

                                }else{
                                    this.notice('error', 'Tranaction Error', "Tranaction Error", 10);
                                }

                                // await this.loadBalances();
                            } catch (error) {
                                console.log(error);
                                this.notice('error', 'Tranaction Error', error.toString(), 10);
                            }


                        } catch (e) {
                            console.error("Transfer Error", e);
                            this.notice('error', 'Error in transfer', e.toString(), 5);

                        }

                        break;
                    case "trc20":
                        console.log("Transfer TRC-20");
                        const trc20token = trc20Tokens.find(element => element.ticker === ticker);
                        console.log(trc20token);
                        try {
                            const modalValue = new BigNumber(this.modalAmount, 10);
                            const base = new BigNumber(10, 10);
                            const pow = new BigNumber(trc20token.prec, 10);
                            const powValue = base.pow(pow);
                            const valueToSend = modalValue.multipliedBy(powValue);
                            console.log(valueToSend.toString());

                            console.log("modalValue", modalValue.toString(10));

                            const parameter = [{type:'address',value:this.modalToAddress},{type:'uint256',value:valueToSend.toFixed()}];
/*
                            const options = {
                                feeLimit:15000000
                            };
*/

                            const options = {};
                            const sendTrc20Obj = await tronWeb.transactionBuilder.triggerSmartContract(
                                tronWeb.address.toHex(trc20token.address),
                                "transfer(address,uint256)",
                                options,
                                parameter,
                                tronWeb.address.toHex(this.trxAddress)
                            );

                            console.log(sendTrc20Obj);

                            try {
                                this.notice('info', 'Confirm Transaction on ledger', `Confirm Transaction on ledger`, 10);
                                const hdPath = `44'/195'/0'/0/${this.accountIndex}`;
                                console.log(hdPath, sendTrc20Obj.transaction.raw_data_hex);
                                const tronAddress = await trx.getAddress(hdPath, false);
                                console.log(tronAddress);
                                const sign = await trx.signTransaction(hdPath, sendTrc20Obj.transaction.raw_data_hex, [], 105);
                                const signedTx = sendTrc20Obj.transaction;
                                signedTx.signature = [sign];
                                console.log("signedTx:", signedTx);
                                const receipt = await tronWeb.trx.sendRawTransaction(
                                    signedTx
                                );
                                if (receipt.result === true) {
                                    console.log(receipt);
                                    this.notice('success', 'Successful', `Successfully sent transaction`);
                                    this.closeModal();
                                    this.txid = receipt.txid;
                                    this.showReceipt = true;
                                    const hey = this;
                                    setTimeout(async function () {
                                        await hey.loadBalances();
                                    }, 30000);

                                }else{
                                    this.notice('error', 'Tranaction Error', "Tranaction Error", 10);
                                }

                                // await this.loadBalances();
                            } catch (error) {
                                console.log(error);
                                this.notice('error', 'Tranaction Error', error.toString(), 10);
                            }


                        } catch (e) {
                            console.error("Transfer Error", e);
                            this.notice('error', 'Error in transfer', e.toString(), 5);

                        }

                        break;
                    default:
                    // code block
                }
            },
            notice(type, title, description, duration) {
                if (duration === undefined) {
                    duration = 1;
                }
                this.$notice[type]({
                    title: title,
                    description: description || "",
                    duration: duration,
                })
            },
            async loadBalances() {
                this.balances = [];
                // TRX native balance
                try {
                    const tronObj = await tronWeb.trx.getAccount(this.trxAddress);
                    const trxRaw = (tronObj.balance || 0) / 1000000;
                    this.balances.push({ ticker: 'TRX', balance: numeral(trxRaw).format('0,0.000000'), rawBalance: trxRaw, type: 'trx' });
                } catch (e) {
                    this.notice('error', 'Cant get TRX balance', e.toString(), 6);
                }
                // TRC20 tokens: always show USDT/BTTC/WIN even at zero balance; filter rest by value > $0.01
                const PINNED_TRC20 = [
                    { ticker: 'USDT', address: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t', decimals: 6  },
                    { ticker: 'BTTC', address: 'TAFjULxiVgT4qWk6UZwjqwZXTSaGaqnVp4', decimals: 18 },
                    { ticker: 'WIN',  address: 'TLa2f6VPqDgRE67v1736s7bJ8Ray5wYjU7',  decimals: 6  },
                ];
                this.tokensLoading = true;
                this.pricingProgress = null;
                loadTronTokens(this.trxAddress, PINNED_TRC20, p => { this.pricingProgress = p; })
                    .then(tokens => {
                        this.balances = this.balances.filter(b => b.type !== 'trc20');
                        this.balances.push(...tokens.map(t => ({
                            ticker: t.ticker,
                            balance: t.balance,
                            rawBalance: t.rawBalance,
                            type: 'trc20',
                            usdValue: t.usdValue,
                            contractAddress: t.contractAddress || t.address,
                        })));
                        if (this.$store) this.$store.commit('wallets/SET_WALLET', { chain: 'tron', data: { address: this.trxAddress, balances: this.balances, connected: true, accountIndex: this.accountIndex } });
                    })
                    .catch(e => this.notice('error', 'Token Load Error', e.message, 6))
                    .finally(() => { this.tokensLoading = false; this.pricingProgress = null; });

                if (this.$store) {
                    this.$store.commit('wallets/SET_WALLET', { chain: 'tron', data: { address: this.trxAddress, balances: this.balances, connected: true, accountIndex: this.accountIndex } });
                }
            },
            async createTransport() {
                const hidOk = await TransportWebHID.isSupported();
                if (hidOk) return await TransportWebHID.create();
                const usbOk = await TransportWebUSB.isSupported();
                if (usbOk) return await TransportWebUSB.create();
                const isSecure = location.protocol === 'https:' || location.hostname === 'localhost';
                if (!isSecure) {
                    throw new Error('Page must be served over HTTPS for Ledger USB access.');
                }
                throw new Error('Ledger USB not supported in this browser. Please use Chrome or Edge.');
            },
            async onGetLedgerBitcoinAddress(e) {
                e.preventDefault();
                this.notice('info', 'Connecting to ledger', `please wait...`, 3);
                try {
                    if (transport) {
                        await transport.close().catch(() => {});
                    }
                    transport = await this.createTransport();
                    trx = new Trx(transport);
                    const hdPath = `44'/195'/0'/0/${this.accountIndex}`;
                    const tronAddress = await trx.getAddress(hdPath, false);
                    this.trxAddress = tronAddress.address;
                    this.hdPath = "m/" + hdPath;
                    this.notice('success', 'Successful', `Successfully loaded address`);
                    await this.loadBalances();
                    await this.refreshPrices();
                    const accounts = saveAccount({ chain: 'tron', hdIndex: this.accountIndex, address: this.trxAddress, label: `Tron #${this.accountIndex}` });
                    if (this.$store) this.$store.commit('accounts/SET_ACCOUNTS', accounts);
                    await this.loadMatrix();
                } catch (error) {
                    console.error(error);
                    this.notice('error', 'Ledger Error', error.message || error.toString(), 10);
                }
            },

            // ── Address Matrix / Tree ──────────────────────────────────────
            // Tron's Ledger app doesn't return a chaincode alongside the pubkey,
            // so (unlike BTC/ETH/BSC/Polygon) sibling addresses can't be derived
            // from a public key alone — the matrix only shows indices already
            // connected via Ledger.
            async loadMatrix(notifyIfEmpty = false) {
                const savedAccounts = getAccounts().filter(a => a.chain === 'tron');
                const cells = savedAccounts
                    .map(a => ({ index: Number(a.hdIndex), address: a.address, balance: null, loading: true }))
                    .sort((a, b) => a.index - b.index);
                this.matrixCells = cells;
                if (!cells.length) {
                    if (notifyIfEmpty) {
                        this.notice('error', 'Address Matrix Empty', 'No connected Tron addresses yet — connect your Ledger to populate it.', 8);
                    }
                    return;
                }
                this.matrixLoading = true;
                const results = await Promise.allSettled(
                    cells.map(async c => ({ index: c.index, tronObj: await tronWeb.trx.getAccount(c.address) }))
                );
                const byIndex = {};
                for (const r of results) {
                    if (r.status === 'fulfilled') byIndex[r.value.index] = (r.value.tronObj.balance || 0) / 1000000;
                    else console.error('[tron matrix] balance fetch rejected:', r.reason);
                }
                this.matrixCells = this.matrixCells.map(c => ({ ...c, balance: byIndex[c.index] ?? 0, loading: !(c.index in byIndex) }));
                this.matrixLoading = false;
            },

            onMatrixSelect(idx) {
                const cell = this.matrixCells.find(c => c.index === idx);
                if (!cell) return;
                this.accountIndex = idx;
                this.trxAddress = cell.address;
                this.hdPath = `m/44'/195'/0'/0/${idx}`;
                this.loadBalances();
            },

            async pingRpc(url) {
                this.$set(this.rpcStatus, url, 'checking');
                try {
                    const res = await fetch(url, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ jsonrpc: '2.0', id: 1, method: 'eth_blockNumber', params: [] }),
                    });
                    this.$set(this.rpcStatus, url, res.ok ? 'ok' : 'error');
                } catch {
                    this.$set(this.rpcStatus, url, 'error');
                }
            },

            switchRpc(url) {
                this.activeRpc = url;
                activeRpcUrl = url;
                tronWeb.setFullNode(url);
                tronWeb.setSolidityNode(url);
                this.pingRpc(url);
            },

            pingAllRpc() {
                this.rpcList.forEach(r => this.pingRpc(r.url));
            },

            // ── Pricing ────────────────────────────────────────────────────
            async refreshPrices() {
                const tickers = this.balances.map(b => b.ticker);
                const { prices } = await fetchPrices(tickers);
                this.prices = prices;
                if (this.$store) this.$store.dispatch('prices/fetchPrices', tickers);
            },

            priceOf(ticker, rawBalance) {
                const raw = parseFloat(String(rawBalance).replace(/,/g, '')) || 0;
                const price = this.prices[ticker] ?? null;
                if (price === null) return '—';
                return '$' + (raw * price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },

            // Numeric USD value for sorting — falls back to live price lookup like priceOf(),
            // but returns -1 (sorts last) when no value can be determined at all.
            usdValueNum(b) {
                const rawBalance = b.rawBalance !== undefined ? b.rawBalance : b.balance;
                if (b.usdValue != null) return b.usdValue;
                const raw = parseFloat(String(rawBalance).replace(/,/g, '')) || 0;
                const price = this.prices[b.ticker] ?? null;
                return price === null ? -1 : raw * price;
            },

            // ── Chart ─────────────────────────────────────────────────────
            setChartMode(mode) {
            this.chartMode = mode;
            if (this.chartLoaded) this.renderChart();
        },

        async loadChart() {
            const addr = this.chartAddress.trim();
            if (!addr || !this.isValidTronAddress(addr)) {
                this.notice('error', 'Invalid Address', 'Enter a valid Tron address starting with T.', 4);
                return;
            }
            this.chartLoading = true;
            this.chartLoaded = false;
            try {
                // Fetch up to 200 most recent confirmed transactions
                const url = `https://api.trongrid.io/v1/accounts/${addr}/transactions?limit=200&only_confirmed=true`;
                const res = await axios.get(url, { headers: { Accept: 'application/json' } });
                const txs = res.data.data || [];

                // Build per-day buckets for the last N days
                const now = Date.now();
                const msPerDay = 86400000;
                const cutoff = now - this.chartDays * msPerDay;

                const countMap = {};
                const sentMap  = {};
                const recvMap  = {};

                // init all days to 0
                for (let d = 0; d < this.chartDays; d++) {
                    const day = this._dayKey(now - d * msPerDay);
                    countMap[day] = 0;
                    sentMap[day]  = 0;
                    recvMap[day]  = 0;
                }

                let totalCount = 0, totalSent = 0, totalRecv = 0;

                txs.forEach(tx => {
                    const ts = tx.block_timestamp || 0;
                    if (ts < cutoff) return;
                    const day = this._dayKey(ts);
                    if (!(day in countMap)) return;

                    countMap[day]++;
                    totalCount++;

                    // TRX native transfer
                    const contracts = (tx.raw_data && tx.raw_data.contract) || [];
                    contracts.forEach(c => {
                        if (c.type === 'TransferContract') {
                            const v = c.parameter && c.parameter.value || {};
                            const amountTrx = (v.amount || 0) / 1e6;
                            const owner = v.owner_address || '';
                            const to    = v.to_address    || '';
                            const addrHex = TronWeb.address.toHex(addr);
                            if (owner === addrHex) { sentMap[day] += amountTrx; totalSent += amountTrx; }
                            if (to    === addrHex) { recvMap[day] += amountTrx; totalRecv += amountTrx; }
                        }
                    });
                });

                this.$set(this, 'chartStats', {
                    total: totalCount,
                    sent:  totalSent.toFixed(2),
                    received: totalRecv.toFixed(2),
                });

                // Sort labels oldest→newest
                const labels = Object.keys(countMap).sort();
                this._chartData = { labels, countMap, sentMap, recvMap };
                this.chartLoaded = true;
                this.$nextTick(() => this.renderChart());
            } catch (e) {
                console.error(e);
                this.notice('error', 'Chart Error', e.message || String(e), 8);
            } finally {
                this.chartLoading = false;
            }
        },

        _dayKey(ms) {
            const d = new Date(ms);
            return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
        },

        renderChart() {
            if (!this._chartData) return;
            const { labels, countMap, sentMap, recvMap } = this._chartData;

            // Destroy old instance
            if (this.chartInstance) {
                this.chartInstance.destroy();
                this.chartInstance = null;
            }

            const ctx = this.$refs.txChart;
            if (!ctx) return;

            let datasets;
            if (this.chartMode === 'count') {
                datasets = [{
                    label: 'TX Count',
                    data: labels.map(l => countMap[l]),
                    backgroundColor: 'rgba(255,0,19,0.7)',
                    borderColor: '#FF0013',
                    borderWidth: 1,
                    borderRadius: 3,
                }];
            } else {
                datasets = [
                    {
                        label: 'TRX Received',
                        data: labels.map(l => recvMap[l]),
                        backgroundColor: 'rgba(40,167,69,0.7)',
                        borderColor: '#28a745',
                        borderWidth: 1,
                        borderRadius: 3,
                        type: 'bar',
                    },
                    {
                        label: 'TRX Sent',
                        data: labels.map(l => sentMap[l]),
                        backgroundColor: 'rgba(255,0,19,0.55)',
                        borderColor: '#FF0013',
                        borderWidth: 1,
                        borderRadius: 3,
                        type: 'bar',
                    },
                ];
            }

            // Shorten labels to MM-DD for readability
            const shortLabels = labels.map(l => l.slice(5));

            this.chartInstance = new Chart(ctx, {
                type: 'bar',
                data: { labels: shortLabels, datasets },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: { mode: 'index', intersect: false },
                    plugins: {
                        legend: { position: 'top' },
                        tooltip: {
                            callbacks: {
                                title: (items) => {
                                    const i = items[0].dataIndex;
                                    return labels[i];
                                },
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: this.chartMode === 'volume',
                            grid: { display: false },
                            ticks: { maxRotation: 45, autoSkip: true, maxTicksLimit: 15 },
                        },
                        y: {
                            stacked: this.chartMode === 'volume',
                            beginAtZero: true,
                            grid: { color: 'rgba(0,0,0,0.05)' },
                        },
                    },
                },
            });
        },

        },

        async mounted() {
            this.fetchAddresses();
            this.pingAllRpc();
            this.priceTimer = setInterval(() => this.refreshPrices(), 60000);
            eventBus.$on('refresh-prices', this.refreshPrices);
            const active = localStorage.getItem('hd_active_tron');
            if (active) {
                const accts = JSON.parse(localStorage.getItem('hd_accounts') || '[]');
                const a = accts.find(x => x.id === active);
                if (a) this.accountIndex = a.hdIndex;
            }
            this.loadMatrix();
        },
        beforeDestroy() {
            clearInterval(this.priceTimer);
            eventBus.$off('refresh-prices', this.refreshPrices);
            if (this.chartInstance) this.chartInstance.destroy();
        },
    }
</script>

<style scoped>
/* ── Tron brand ── */
.btn-success {
  background: rgba(255,0,19,0.18) !important;
  border-color: rgba(255,0,19,0.5) !important;
  color: #ff6b7a !important;
  font-weight: 600 !important;
}
.btn-success:hover {
  background: rgba(255,0,19,0.32) !important;
  color: #fff !important;
}
.btn-primary {
  background: #FF0013 !important;
  border-color: #FF0013 !important;
  color: #fff !important;
}
.btn-primary:hover {
  background: #cc000f !important;
  border-color: #cc000f !important;
  color: #fff !important;
}
.table thead th {
  background: rgba(255,0,19,0.15) !important;
  color: #ff6b7a !important;
  border-bottom: 2px solid rgba(255,0,19,0.4) !important;
}

/* ── RPC panel ── */
.rpc-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px 14px;
  background: var(--surface, #111520);
  border-radius: 10px;
  border: 1px solid var(--border, #242a3a);
  margin-bottom: 4px;
}
.rpc-title {
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--text-muted, #52597a);
  margin-right: 4px;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}
.rpc-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.78rem;
  font-weight: 500;
  padding: 4px 11px;
  border-radius: 20px;
  cursor: pointer;
  border: 1px solid var(--border, #242a3a);
  background: var(--surface-2, #171b28);
  color: var(--text, #c8cfe8);
  transition: all 0.18s;
}
.rpc-item:hover { border-color: #FF0013; background: rgba(255,0,19,0.08); }
.rpc-active { border-color: #FF0013 !important; background: rgba(255,0,19,0.14) !important; color: #fff !important; font-weight: 700 !important; }
.rpc-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: var(--border-2, #2e3650);
  display: inline-block;
  flex-shrink: 0;
}
.rpc-dot.ok       { background: #22c55e; }
.rpc-dot.error    { background: #f43f5e; }
.rpc-dot.checking { background: #f59e0b; }

/* ── Chart panel ── */
.btn-tron {
  background: #FF0013 !important;
  border-color: #FF0013 !important;
  color: #fff !important;
  font-weight: 700 !important;
}
.btn-tron:hover, .btn-tron:focus {
  background: #cc000f !important;
  color: #fff !important;
}
.chart-panel {
  border: 1px solid var(--border, #242a3a);
  border-radius: 12px;
  padding: 18px;
  background: var(--surface, #111520);
  box-shadow: 0 4px 24px rgba(0,0,0,0.4);
}
.chart-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.chart-panel-title {
  font-weight: 700;
  font-size: 0.86rem;
  color: var(--text, #c8cfe8);
  margin-right: 6px;
  white-space: nowrap;
}
.chart-input-group { display: flex; gap: 6px; flex: 1; min-width: 200px; }
.chart-addr-input  { flex: 1; font-size: 0.82rem; }
.chart-toggles     { display: flex; gap: 4px; }
.chart-summary {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 10px;
  font-size: 0.8rem;
  padding: 8px 12px;
  background: var(--surface-2, #171b28);
  border-radius: 8px;
}
.chart-stat { display: flex; align-items: center; gap: 4px; }
.stat-in  { color: #22c55e; font-weight: 700; }
.stat-out { color: #FF0013; font-weight: 700; }
.chart-wrapper { position: relative; height: 280px; }
.chart-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-muted, #52597a);
  font-size: 0.88rem;
  background: rgba(11,13,20,0.88);
  border-radius: 10px;
}
</style>
